import axios from '../../axios'

/**
 * 查询
 */
export const findPage = data => {
  return axios({
    url: '/stucard/list',
    method: 'post',
    data
  })
}

/**
 * 导出 Excel
 * @param schoolId 驾校id
 * @param idnum 芯片号码
 * @param serialNum 流水号
 * @param sendFlag 状态
 */
export const exportExcel = data => {
  return axios({
    url: '/stucard/exportExcel',
    method: 'post',
    responseType: 'blob',
    data,
  })
}

/**
 * 导入excel
 */
export const importStuCard = (data) => {
  return axios({
    url: '/stucard/import',
    method: 'post',
    data
  })
}
// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/stucard/delete',
    method: 'post',
    data
  })
}
/**
 * 查询卡
 */
export const findStuCard = (data) => {
  return axios({
    url: '/stucard/find',
    method: 'post',
    data
  })
}

/**
 * 发放学员卡
 */
export const handOutStuCard = (data) => {
  return axios({
    url: '/stucard/handOutStu',
    method: 'post',
    data
  })
}

/**
 * 发放教练员卡
 */
export const handOutCoachCard = (data) => {
  return axios({
    url: '/stucard/handOutCoach',
    method: 'post',
    data
  })
}

/**
 * 发放教考试核员卡
 */
export const handOutExamCard = (data) => {
  return axios({
    url: '/stucard/handOutExam',
    method: 'post',
    data
  })
}






// WEBPACK FOOTER //
// ./src/http/modules/stucard/stucard.js